import React from 'react';
import SelectDetailedInputComponent from './SelectDetailedInputComponent';
import SelectDetailedRiskAnalysis from '../../../../../../risk-analysis/src/components/input/SelectDetailedInputComponent';
import { isSalesConversationFlow } from '../../../../../../common/src/utils/globalVariables';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}

const SelectDetailedPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  if (isSalesConversationFlow())
    return <SelectDetailedInputComponent question={question} />;
  return <SelectDetailedRiskAnalysis question={question} />;
};

export default SelectDetailedPicker;
